import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import TooltipOnEllipsis from '../tooltipOnEllipsis/tooltipOnEllipsis';
import TextLabelBase from './textLabelBase';
var ellipsisPropsNames = ['closeOnMouseClick', 'contentClassName', 'customTrigger', 'customTooltipMessage', 'displayCustomTrigger', 'marginTop', 'marginLeft'];
var TextLabel = /*#__PURE__*/function (_React$Component) {
  function TextLabel(props) {
    var _this;
    _classCallCheck(this, TextLabel);
    _this = _callSuper(this, TextLabel, [props]);
    _this.getTextLabelBaseProps = function () {
      return _(_this.props).pick(['value', 'type', 'disabled', 'shouldTranslate']).assign({
        key: "".concat(_this.props.value, "-").concat(_this.props.type)
      }).value();
    };
    _this.getTooltipOnEllipsisProps = function () {
      return _this.props.ellipsisProps ? _.pick(_this.props.ellipsisProps, _.concat(ellipsisPropsNames, 'disabled', 'shouldTranslate')) : {};
    };
    return _this;
  }
  _inherits(TextLabel, _React$Component);
  return _createClass(TextLabel, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("span", {
        className: this.props.getClassName('control-label' + (this.props.disabled ? ' disabled' : '') + (this.props.enableEllipsis ? ' with-ellipsis' : '')),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, this.props.enableEllipsis ? /*#__PURE__*/React.createElement(TooltipOnEllipsis, _extends({
        key: "tooltipOnEllipsisOnTextLabel"
      }, this.getTooltipOnEllipsisProps()), /*#__PURE__*/React.createElement(TextLabelBase, this.getTextLabelBaseProps())) : /*#__PURE__*/React.createElement(TextLabelBase, _extends({
        key: "tooltipOnEllipsisOnTextLabel"
      }, this.getTextLabelBaseProps())));
    }
  }]);
}(React.Component);
TextLabel.displayName = 'TextLabel';
TextLabel.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** The actual text to be rendered */
  value: PropTypes.string.isRequired,
  /** The type of text style */
  type: PropTypes.oneOf(['T01', 'T02', 'T03', 'T04', 'T05', 'T06', 'T07', 'T08', 'T09', 'T10', 'T11', 'T12', 'T13', 'T14', 'T15', 'T16', 'T17', 'T18', 'T19', 'T20', 'T21']),
  /** Applies disabled styles */
  disabled: PropTypes.bool,
  /** When set to false the text goes multiline without ellipsis nor tooltip */
  enableEllipsis: PropTypes.bool,
  /** Custom props to override the default behaviour of the wrapping ToolTipOnEllipsis component */
  ellipsisProps: PropTypes.shape(_.pick(TooltipOnEllipsis, ellipsisPropsNames))
};
TextLabel.defaultProps = {
  disabled: false,
  enableEllipsis: true
};
export default compose(TextLabel);